import { NgModule } from "@angular/core"
import { RouterModule, Routes, UrlSegment } from "@angular/router"

import { ErrorComponent } from "../error/error.component"
import { ErrorModule } from "../error/error.module"
import { ResourceComponent } from "./resource.component"
import { ResourcePreviewGuard } from "./guards/resource-preview.guard"

export function customMatcher(url: UrlSegment[]) {
    if (url.length <= 2) {
        return null
    }
    const codeSegment = new UrlSegment(url[0].path, {
        resourceCode: url[0].path,
    })
    const slugSegment = new UrlSegment(url[1].path, { slug: url[1].path })
    return {
        consumed: url,
        posParams: { resourceCode: codeSegment, slug: slugSegment },
    }
}

const resourceRoutes: Routes = [
    {
        path: ":resourceCode/:slug/preview",
        component: ResourceComponent,
        canActivate: [ResourcePreviewGuard],
        canDeactivate: [ResourcePreviewGuard],
    },
    { path: ":resourceCode/:slug", component: ResourceComponent },
    { path: ":resourceCode", component: ResourceComponent },
    { matcher: customMatcher, component: ResourceComponent },
    { path: "", component: ErrorComponent },
]

@NgModule({
    imports: [RouterModule.forChild(resourceRoutes), ErrorModule],
    exports: [RouterModule],
})
export class ResourceRoutingModule {}
